import uuid from "react-uuid";
import { persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { actionTypes } from "./actions";

// Bump version + add a new migration entry to force-reset isInfoSeen for all users
const migrations = {
  1: (state) => ({ ...state, isInfoSeen: false }),
}; 

const initialCommonState = {
  loading: false,
  tempAddress: undefined,
  onboarding: false,
  channelId: "B2C",
  channel_toggle: false,
  isInfoSeen: false,
  uuid: uuid(),
};

export const reducer = persistReducer(
  {
    storage,
    key: "shine-common-variables",
    version: 1,
    migrate: createMigrate(migrations, { debug: false }),
    blacklist: ["loading"],
  },
  (state = initialCommonState, action) => {
    switch (action.type) {
      case actionTypes.SET_LOADING_ON: {
        return {
          ...state,
          loading: action.payload,
        };
      }

      case actionTypes.SET_LOADING_OFF: {
        return {
          ...state,
          loading: action.payload,
        };
      }

      case actionTypes.SET_TEMP_ADDRESS: {
        return {
          ...state,
          tempAddress: action.payload,
        };
      }

      case actionTypes.SET_ON_BOARDING: {
        return {
          ...state,
          onboarding: action.payload,
        };
      }

      case actionTypes.SET_USER_CHANNELS: {
        return {
          ...state,
          ...action.payload,
        };
      }

      case actionTypes.SET_INFO_MODAL: {
        return {
          ...state,
          isInfoSeen: action.payload.state,
        };
      }

      case actionTypes.RESET_USER_VARIABLES:
        return { ...initialCommonState, uuid: uuid(), onboarding: true };

      default:
        return state;
    }
  },
);
